module.exports = __webpack_public_path__ + "static/media/money.0d77f160.png";